import { FaMoneyBillTransfer } from "react-icons/fa6";
import { GiSandsOfTime, GiTakeMyMoney } from "react-icons/gi";
import { MdNumbers } from "react-icons/md";
import { SlCalender } from "react-icons/sl";
const SkeletonCard = () => (
  <div
    className="relative overflow-hidden rounded-[2rem] p-6 
               bg-gray-100 dark:bg-white/5 border border-white dark:border-white/10 shadow-sm"
  >
    {/* Header Skeleton: رقم الفاتورة و الـ Status Badge */}
    <div className="flex justify-between items-start mb-6">
      <div className="flex flex-col gap-2">
        {/* تسمية رقم الفاتورة */}
        <div className="w-16 h-2 rounded bg-gray-300 dark:bg-white/10 animate-pulse" />
        {/* الرقم نفسه */}
        <div className="w-24 h-4 rounded-lg bg-mainLight/20 animate-pulse" />
      </div>
      {/* الـ Badge المستدير */}
      <div className="w-20 h-7 rounded-full bg-gray-200 dark:bg-white/10 animate-pulse" />
    </div>

    {/* الوسط: إجمالي الحجز */}
    <div className="space-y-4 mb-6">
      <div className="flex justify-between items-end">
        {/* تسمية إجمالي الحجز */}
        <div className="w-20 h-3 rounded bg-gray-200 dark:bg-white/5 animate-pulse" />
        {/* المبلغ الكبير */}
        <div className="flex items-baseline gap-1">
          <div className="w-24 h-8 rounded-xl bg-gray-300 dark:bg-white/10 animate-pulse" />
          <div className="w-8 h-3 rounded bg-mainLight/20 animate-pulse" />
        </div>
      </div>

      {/* الخط الفاصل المتدرج */}
      <div className="h-[1px] w-full bg-gradient-to-r from-transparent via-gray-200 dark:via-white/10 to-transparent" />

      {/* الجزء السفلي: التاريخ والمدفوع */}
      <div className="flex justify-between items-center">
        {/* أيقونة + تاريخ */}
        <div className="flex items-center gap-2">
          <div className="w-4 h-4 rounded-full bg-gray-200 dark:bg-white/10 animate-pulse" />
          <div className="w-28 h-3 rounded bg-gray-200 dark:bg-white/5 animate-pulse" />
        </div>
        {/* المبلغ المدفوع */}
        <div className="w-16 h-4 rounded-lg bg-green-500/10 animate-pulse" />
      </div>
    </div>

    {/* الشريط السفلي الذي يظهر عند الـ Hover في الكرت الحقيقي */}
    <div className="absolute bottom-0 left-0 right-0 h-1 bg-gray-200 dark:bg-white/5" />
  </div>
);

const SkeletonMyOrder = ({ number = 6 }) => (
  <div className="w-full">
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
      {Array(number)
        .fill(0)
        .map((_, index) => (
          <SkeletonCard key={index} />
        ))}
    </div>
  </div>
);

export default SkeletonMyOrder;
